import(/* webpackMode: "eager" */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/common/FeedbackModal/ButtonCTA.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/common/ImageBg.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/page-index/BenefitCardAnimation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/page-index/BenefitSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/page-index/MobileAppServicesAnimation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/page-index/ServiceFeaturedSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/page-index/SpecialistFeaturedList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/page-index/Welcome.tsx");
